import { http } from '@/utils/http';
import qs from 'qs';

interface IGetNewsListOption {
  target: string;
  page: number;
}
interface IRegisterOption {
  name: string;
  jzname: string;
  phone: number | string;
  experience: string;
  udid?: string | number;
  appkey?: string | number;
}
const urlPrefix = '/vote/2019poject/2019football/controller.php?enews=';

export const getNewsList = async ({ target, page }: IGetNewsListOption) => {
  const ret = await http.get(urlPrefix + target, {
    params: {
      page,
    },
  });
  return ret;
};

export const register = async ({
  name,
  jzname,
  phone,
  experience,
  appkey,
  udid,
}: IRegisterOption) => {
  const ret = await http.post(
    urlPrefix + 'save',
    qs.stringify({ name, jzname, phone, experience, appkey, udid }),
  );
  return ret;
};

export const getBaseInfo = async () => {
  const ret = await http.get(urlPrefix + 'base-info');
  return ret;
};
